import { SubscriptionTier } from '../../../../type';
import type { SubscriptionTiersTable } from '../../../components/ComparePackages/types';
import { appTranslate } from '../../../i18n';
import { AvailabilityStatus } from '../../enums';

export const getSubscriptionTiersTable = (): SubscriptionTiersTable => ({
    serviceOptions: [
        {
            id: 'option_1',
            name: appTranslate('compare_packages.microsoft.service_options.option_1.name'),
            subOptions: [
                {
                    id: 'sub_option_1',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_1.sub_options.sub_option_1.name'
                    ),
                },
                {
                    id: 'sub_option_2',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_1.sub_options.sub_option_2.name'
                    ),
                },
                {
                    id: 'sub_option_3',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_1.sub_options.sub_option_3.name'
                    ),
                },
                {
                    id: 'sub_option_4',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_1.sub_options.sub_option_4.name'
                    ),
                },
            ],
        },
        {
            id: 'option_2',
            name: appTranslate('compare_packages.microsoft.service_options.option_2.name'),
            subOptions: [
                {
                    id: 'sub_option_1',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_2.sub_options.sub_option_1.name'
                    ),
                },
                {
                    id: 'sub_option_2',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_2.sub_options.sub_option_2.name'
                    ),
                },
                {
                    id: 'sub_option_3',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_2.sub_options.sub_option_3.name'
                    ),
                },
                {
                    id: 'sub_option_4',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_2.sub_options.sub_option_4.name'
                    ),
                },
            ],
        },
        {
            id: 'option_3',
            name: appTranslate('compare_packages.microsoft.service_options.option_3.name'),
            subOptions: [
                {
                    id: 'sub_option_1',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_3.sub_options.sub_option_1.name'
                    ),
                },
                {
                    id: 'sub_option_2',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_3.sub_options.sub_option_2.name'
                    ),
                },
                {
                    id: 'sub_option_3',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_3.sub_options.sub_option_3.name'
                    ),
                },
                {
                    id: 'sub_option_4',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_3.sub_options.sub_option_4.name'
                    ),
                },
            ],
        },
        {
            id: 'option_4',
            name: appTranslate('compare_packages.microsoft.service_options.option_4.name'),
            subOptions: [
                {
                    id: 'sub_option_1',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_4.sub_options.sub_option_1.name'
                    ),
                },
                {
                    id: 'sub_option_2',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_4.sub_options.sub_option_2.name'
                    ),
                },
                {
                    id: 'sub_option_3',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_4.sub_options.sub_option_3.name'
                    ),
                },
                {
                    id: 'sub_option_4',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_4.sub_options.sub_option_4.name'
                    ),
                },
            ],
        },
        {
            id: 'option_5',
            name: appTranslate('compare_packages.microsoft.service_options.option_5.name'),
            subOptions: [
                {
                    id: 'sub_option_1',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_5.sub_options.sub_option_1.name'
                    ),
                },
                {
                    id: 'sub_option_2',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_5.sub_options.sub_option_2.name'
                    ),
                },
                {
                    id: 'sub_option_3',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_5.sub_options.sub_option_3.name'
                    ),
                },
                {
                    id: 'sub_option_4',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_5.sub_options.sub_option_4.name'
                    ),
                },
            ],
        },
        {
            id: 'option_6',
            name: appTranslate('compare_packages.microsoft.service_options.option_6.name'),
            subOptions: [
                {
                    id: 'sub_option_1',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_6.sub_options.sub_option_1.name'
                    ),
                },
                {
                    id: 'sub_option_2',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_6.sub_options.sub_option_2.name'
                    ),
                },
                {
                    id: 'sub_option_3',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_6.sub_options.sub_option_3.name'
                    ),
                },
            ],
        },
        {
            id: 'option_7',
            name: appTranslate('compare_packages.microsoft.service_options.option_7.name'),
            subOptions: [
                {
                    id: 'sub_option_1',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_7.sub_options.sub_option_1.name'
                    ),
                },
                {
                    id: 'sub_option_2',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_7.sub_options.sub_option_2.name'
                    ),
                },
            ],
        },
        {
            id: 'option_9',
            name: appTranslate('compare_packages.microsoft.service_options.option_9.name'),
            subOptions: [
                {
                    id: 'sub_option_1',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_9.sub_options.sub_option_1.name'
                    ),
                },
                {
                    id: 'sub_option_2',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_9.sub_options.sub_option_2.name'
                    ),
                },
                {
                    id: 'sub_option_3',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_9.sub_options.sub_option_3.name'
                    ),
                },
                {
                    id: 'sub_option_4',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_9.sub_options.sub_option_4.name'
                    ),
                },
                {
                    id: 'sub_option_5',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_9.sub_options.sub_option_5.name'
                    ),
                },
            ],
        },
        {
            id: 'option_10',
            name: appTranslate('compare_packages.microsoft.service_options.option_10.name'),
            subOptions: [
                {
                    id: 'sub_option_1',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_10.sub_options.sub_option_1.name'
                    ),
                },
                {
                    id: 'sub_option_2',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_10.sub_options.sub_option_2.name'
                    ),
                },
                {
                    id: 'sub_option_3',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_10.sub_options.sub_option_3.name'
                    ),
                },
            ],
        },
        {
            id: 'option_11',
            name: appTranslate('compare_packages.microsoft.service_options.option_11.name'),
            subOptions: [
                {
                    id: 'sub_option_1',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_11.sub_options.sub_option_1.name'
                    ),
                },
                {
                    id: 'sub_option_2',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_11.sub_options.sub_option_2.name'
                    ),
                },
                {
                    id: 'sub_option_3',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_11.sub_options.sub_option_3.name'
                    ),
                },
            ],
        },
        {
            id: 'option_12',
            name: appTranslate('compare_packages.microsoft.service_options.option_12.name'),
            subOptions: [
                {
                    id: 'sub_option_1',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_12.sub_options.sub_option_1.name'
                    ),
                },
                {
                    id: 'sub_option_2',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_12.sub_options.sub_option_2.name'
                    ),
                },
                {
                    id: 'sub_option_3',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_12.sub_options.sub_option_3.name'
                    ),
                },
                {
                    id: 'sub_option_4',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_12.sub_options.sub_option_4.name'
                    ),
                },
            ],
        },
        {
            id: 'option_13',
            name: appTranslate('compare_packages.microsoft.service_options.option_13.name'),
            subOptions: [
                {
                    id: 'sub_option_1',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_13.sub_options.sub_option_1.name'
                    ),
                },
                {
                    id: 'sub_option_2',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_13.sub_options.sub_option_2.name'
                    ),
                },
                {
                    id: 'sub_option_3',
                    name: appTranslate(
                        'compare_packages.microsoft.service_options.option_13.sub_options.sub_option_3.name'
                    ),
                },
            ],
        },
    ],
    tiersDetails: [
        {
            id: SubscriptionTier.Basic,
            name: appTranslate('common.subscription_tiers.business_basic'),
            vendor: appTranslate('common.vendors.microsoft_365'),
            options: [
                {
                    optionId: 'option_1',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_2',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_3',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_4',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_5',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_6',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_7',
                    availabilityStatus: AvailabilityStatus.No,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                    ],
                },
                {
                    optionId: 'option_8',
                    availabilityStatus: AvailabilityStatus.Partial,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Partial,
                        },
                    ],
                },
                {
                    optionId: 'option_9',
                    availabilityStatus: AvailabilityStatus.Partial,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_5',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                    ],
                },
                {
                    optionId: 'option_10',
                    availabilityStatus: AvailabilityStatus.No,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                    ],
                },
                {
                    optionId: 'option_11',
                    availabilityStatus: AvailabilityStatus.No,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                    ],
                },
                {
                    optionId: 'option_12',
                    availabilityStatus: AvailabilityStatus.No,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                    ],
                },
                {
                    optionId: 'option_13',
                    availabilityStatus: AvailabilityStatus.No,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                    ],
                },
            ],
        },
        {
            id: SubscriptionTier.Standard,
            name: appTranslate('common.subscription_tiers.business_standard'),
            vendor: appTranslate('common.vendors.microsoft_365'),
            options: [
                {
                    optionId: 'option_1',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_2',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_3',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_4',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_5',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_6',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_7',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_8',
                    availabilityStatus: AvailabilityStatus.Partial,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Partial,
                        },
                    ],
                },
                {
                    optionId: 'option_9',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_5',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_10',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_11',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_12',
                    availabilityStatus: AvailabilityStatus.No,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                    ],
                },
                {
                    optionId: 'option_13',
                    availabilityStatus: AvailabilityStatus.No,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                    ],
                },
            ],
        },
        {
            id: SubscriptionTier.Premium,
            name: appTranslate('common.subscription_tiers.business_premium'),
            vendor: appTranslate('common.vendors.microsoft_365'),
            options: [
                {
                    optionId: 'option_1',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_2',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_3',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_4',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_5',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_6',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_7',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_8',
                    availabilityStatus: AvailabilityStatus.Partial,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Partial,
                        },
                    ],
                },
                {
                    optionId: 'option_9',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_5',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_10',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_11',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_12',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_13',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
            ],
        },
        {
            id: SubscriptionTier.Apps,
            name: appTranslate('common.subscription_tiers.apps_for_business'),
            vendor: appTranslate('common.vendors.microsoft_365'),
            options: [
                {
                    optionId: 'option_1',
                    availabilityStatus: AvailabilityStatus.No,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                    ],
                },
                {
                    optionId: 'option_2',
                    availabilityStatus: AvailabilityStatus.Partial,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                    ],
                },
                {
                    optionId: 'option_3',
                    availabilityStatus: AvailabilityStatus.No,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                    ],
                },
                {
                    optionId: 'option_4',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_5',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_6',
                    availabilityStatus: AvailabilityStatus.Partial,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Partial,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                    ],
                },
                {
                    optionId: 'option_7',
                    availabilityStatus: AvailabilityStatus.Yes,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                    ],
                },
                {
                    optionId: 'option_8',
                    availabilityStatus: AvailabilityStatus.Partial,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Partial,
                        },
                    ],
                },
                {
                    optionId: 'option_9',
                    availabilityStatus: AvailabilityStatus.No,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.Yes,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_5',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                    ],
                },
                {
                    optionId: 'option_10',
                    availabilityStatus: AvailabilityStatus.No,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                    ],
                },
                {
                    optionId: 'option_11',
                    availabilityStatus: AvailabilityStatus.No,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                    ],
                },
                {
                    optionId: 'option_12',
                    availabilityStatus: AvailabilityStatus.No,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_4',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                    ],
                },
                {
                    optionId: 'option_13',
                    availabilityStatus: AvailabilityStatus.No,
                    subOptions: [
                        {
                            optionId: 'sub_option_1',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_2',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                        {
                            optionId: 'sub_option_3',
                            availabilityStatus: AvailabilityStatus.No,
                        },
                    ],
                },
            ],
        },
    ],
});
